import React, { useEffect, useState } from 'react';
import { Input, Modal, DatePicker, Button } from 'antd'
import { ErrorMessage, Form, Formik } from 'formik';
import holidayValidationSchema from './HolidayValidationSchema';
import dayjs from 'dayjs';
import { useGetApiRequests } from '../../../common/CommonExport';
import PopupModal from '../../employee/employee-details/employee-profile/modal/PopupModal';
import { EditHolidayProps, HolidayFormValues, HolidayPayload, HolidayPathParams, HolidayResponse } from './HolidaysTypes';
import { CommonError } from '../../../common/types';

const EditHoliday = (props: EditHolidayProps) => {
  const { open, handleClosepopup, editRecord, isEdit, holidayApi } = props;
  const dateFormat = 'DD.MM.YYYY';
  const editHolidayApi = useGetApiRequests('editHoliday', 'PUT');
  const holidayDate = editRecord?.holidayOn;
  const [loader, setLoader] = useState(false);
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true)
  const [initialValues, setInitialValues] = useState<HolidayFormValues>({
    holidayName: '',
    holidayDate: ''
  })
  const handleCloseModal = () => {
    handleClosepopup()
  }
  const handleClose = () => {
    setPopModal(false)
    handleCloseModal()
  }
  useEffect(() => {
    if (isEdit && editRecord) {
      setInitialValues({
        holidayName: editRecord?.name,
        holidayDate: editRecord?.holidayOn
      })
    }
  }, [isEdit, editRecord])

  const handleHolidayDate = (date: dayjs.Dayjs | null, dateString: string | string[], setFieldValue: (field: string, value: string, shouldValidate?: boolean) => void) => {

    const dateStr = Array.isArray(dateString) ? dateString[0] : dateString;
    setFieldValue('holidayDate', dateStr)
  }

  const convertDateFormat = (dateString: string) => {
    if (!dateString) return '';
    const dateParts = dateString.split('.');
    if (dateParts.length !== 3) return dateString; // fallback
    const formattedDate = `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}`;
    return formattedDate;
  }

  const handleSubmit = (values: HolidayFormValues) => {
    setLoader(true);
    const payload: HolidayPayload = {
      "holidayDetailId": editRecord?.key ?? '',
      "name": values?.holidayName,
      "holidayOn": convertDateFormat(values?.holidayDate)
    }
    const pathParams: HolidayPathParams = {
      id: editRecord?.key ?? ''
    }
    editHolidayApi(payload, '', pathParams)
      .then((response: unknown) => {
        const res = response as { data: HolidayResponse };
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(res?.data?.message || '')
        setModalResponse('success')
        setTimeout(() => {
          setLoader(false)
          handleClose()
        }, 1500)

        holidayApi();
      })
      .catch((err: unknown) => {
        const error = err as CommonError;
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(error?.message)
        setModalResponse('error')
        setTimeout(() => {
          setLoader(false)
          handleClose()
        }, 1500)

      });
  }
  return (
    <div>
      <Modal title={'Edit Holiday'} centered open={open} onCancel={() => handleCloseModal()} footer={null} className="modal-uploadDocument" maskClosable={!loader} keyboard={!loader} closable={!loader}>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          values={initialValues}
          enableReinitialize={true}
          validationSchema={holidayValidationSchema}
        >
          {({ values, errors, handleSubmit, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div className="p-6 documentUpload holiday">
                  <div className="attenance-upload">
                    <div className='form-item'>
                      <div className=' chapter-document flex justify-between w-full py-4'>
                        <label className='w-28 text-[#878787] flex items-center text-[16px]'>Holiday Name*</label>
                        <div className='w-[65%] pt-[2px]'>
                          <Input name='holidayName' className='w-full h-11' placeholder="Pooja Holidays" value={values?.holidayName} onChange={(e) => setFieldValue('holidayName', e.target.value)} />
                          <ErrorMessage name="holidayName" component="div" className="error-message text-left mt-[3px]" />
                        </div>
                      </div>
                      <div className=' chapter-document justify-between flex w-full py-2'>
                        <label className='w-28 text-[#878787] flex items-center text-[16px]'>Date*</label>
                        <div className='w-[65%] margin-top '>
                          <DatePicker name='holidayDate' defaultValue={dayjs(holidayDate, dateFormat)} format="DD.MM.YYYY"
                            className='w-full h-11 ' onChange={(date, dateString) => handleHolidayDate(date, dateString, setFieldValue)} />
                          <div>
                            <ErrorMessage name="holidayDate" component="div" className="error-message text-left mt-[3px]" />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end mt-20 salary_add-btn">
                    <button disabled={loader} className="addButton cancel-leave  w-32 mr-5" onClick={() => handleCloseModal()}>Cancel</button>
                    <Button type='primary' htmlType='submit' className="addButton w-32" loading={loader}>Save</Button>
                  </div>
                </div>
              </Form>
            )
          }}
        </Formik>

      </Modal>
      {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClose} response={modalResponse} modalButtonShow={modalButtonShow} />}
    </div>
  )
}

export default EditHoliday